import { Fieldset, Grid } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import type { UseFormReturnType } from '@mantine/form';
import { IconCalendar, IconUsersGroup } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { FormBranchSelector } from '../../../components/form/FormBranchSelector';
import { FormGenericSelector } from '../../../components/form/FormGenericSelector';
import { FormTillSelector } from '../../../components/form/FormTillSelector';
import {
	defaultIconStyle,
	inputIconStyle,
} from '../../../theme/styling/iconStyling';
import { useBranchOptions } from '../../../util/api/commonQueries';

type UpsertPromotionFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
	selectedBranchId: string;
};

export function UpsertAttendanceForm({
	form,
	selectedBranchId,
}: UpsertPromotionFormProps) {
	const pharmaciesQuery = useBranchOptions();
	const { organisation } = useParams();

	return (
		<>
			<Fieldset>
				<Grid>
					<Grid.Col span={6}>
						<DateTimePicker
							clearable
							label="Start Date/Time"
							placeholder="Pick start date..."
							leftSection={<IconCalendar {...inputIconStyle} />}
							{...form.getInputProps('startTime')}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<DateTimePicker
							clearable
							label="End Date/Time"
							placeholder="Pick end date..."
							leftSection={<IconCalendar {...inputIconStyle} />}
							{...form.getInputProps('endTime')}
						/>
					</Grid.Col>
					<Grid.Col span={4}>
						<FormBranchSelector form={form} property={'branchId'} />
					</Grid.Col>
					<Grid.Col span={4}>
						<FormTillSelector
							form={form}
							property={'tillNo'}
							branchId={selectedBranchId}
							branchOptions={pharmaciesQuery.data?.value}
						/>
					</Grid.Col>
					<Grid.Col span={4}>
						<FormGenericSelector
							label={'Staff Member'}
							placeholder={'Select staff member...'}
							icon={<IconUsersGroup {...defaultIconStyle} />}
							form={form}
							property={'operatorId'}
							apiRoute={`${organisation}/operators/options`}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
